


























import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { MigrationImport } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import FormattedNumber from "@/components/common/Inputs/FormattedNumber.vue";
import TableComponent from "./Components/DetailedListingTable.vue";
import { DetailedListing } from "@/entities/grants";

const namespace: string = "migration";
@Component({
  components: {
    TableComponent,
    FormattedNumber,
  },
})
export default class PersonnelCostComponent extends Vue {
  @State(namespace) migration!: MigrationImport;

  @Prop() schema: any;
  @Prop() model: any;
  @Prop() validations: any;
  @Prop() formOptions: any;

  mounted() {}

  get dataModel() {
    if (!this.model.detailedListing) {
      this.model.detailedListing = [];
    }
    return this.model.detailedListing;
  }

  get header() {
    if (
      this.schema &&
      this.schema.detailedListingHeaders
    ) {
      return this.schema.detailedListingHeaders.items;
    }
  }

  get grantInfo() {
    let grantData: any = {};

    grantData.StartDate = this.migration.ImportData.projectStartDate;
    grantData.EndDate = this.migration.ImportData.projectEndDate;
    grantData.AgreementDate = this.migration.ImportData.grantAgreementDate;

    return grantData;
  }

  get budgetCategories() {
    return this.migration.BudgetCategories;
  }

  get budget() {
    let obj: any = {};
    if (
      this.migration.ImportData &&
      this.migration.ImportData.applicationBudget
    ) {
      obj = this.migration.ImportData.applicationBudget;
    }
    return obj;
  }

  aggregate(item: DetailedListing) {
    item.amountInEUR =
      (item.amountInOriginalCurrency || 0) * (item.exchangeRate || 0);
    this.updateStatement(item.budgetLine);
  }

  /** update the statement */
  updateStatement(budgetLine: string) {
    if (this.model.statementOfExpeditures) {
      /***details  */
      var exp = this.model.statementOfExpeditures.find(
        (x) => x.activityCode == budgetLine
      );

      if (exp) {
        /** statement */
        let oldVal: number = exp.currentExpenditure;
        exp.currentExpenditure = this.dataModel
          .filter((x) => x.budgetLine == budgetLine)
          .map((x) => x.amountInEUR)
          .reduce((a, b) => a + b || 0, 0);
        exp.totalExpenditure =
          exp.totalExpenditure + (exp.currentExpenditure - (oldVal || 0));
        exp.availableAmount = exp.amountBudgeted - exp.totalExpenditure;
      }

      /** consolidation */
      this.model.consolidation.expenditureSummary = this.dataModel
        .filter((x) => !x.isBankingCharges)
        .map((x) => x.amountInEUR)
        .reduce((a, b) => a + b || 0, 0);
      this.model.consolidation.bankCharges = this.dataModel
        .filter((x) => x.isBankingCharges)
        .map((x) => x.amountInEUR)
        .reduce((a, b) => a + b || 0, 0);
      this.model.consolidation.totalExpenditure =
        this.model.consolidation.expenditureSummary +
        this.model.consolidation.bankCharges;
      this.model.consolidation.totalCredited =
        (this.model.consolidation.balanceAtBeginning || 0) +
        (this.model.consolidation.fundInflow || 0) +
        (this.model.consolidation.creditInterest || 0);
      this.model.consolidation.balance =
        this.model.consolidation.totalCredited -
        (this.model.consolidation.totalExpenditure ?? 0);
      this.model.consolidation.replenishAmount =
        (this.model.consolidation.forecast ?? 0) - this.model.consolidation.balance;
    }
  }
}
